import { render, staticRenderFns } from "./system-health.vue?vue&type=template&id=31d2f581&"
import script from "./system-health.vue?vue&type=script&lang=js&"
export * from "./system-health.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports